import React from "react";
import Error from "../Assests/images/404.png"
import Errorbutton from "../Assests/images/Error.png"



class Error404 extends React.Component {
  constructor(props) {
    super(props);

  }
  render() {
    return (
      <div className="App">



        <section className=" internal-page-padding-top pb-5">
          <div className="container">
            <div className="row">
              <div className="col text-center">
                <img src={Error} alt="Error404" className="Error404-image mx-auto" />
                <br />
                <a href="/"><img src={Errorbutton} alt="Error404" className="Error404-image-home-button mx-auto" /></a>
              </div>
            </div>
          </div>
        </section>





      </div>
    );
  }
}

export default Error404;
